import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  IconButton,
  Modal,
  Typography,
} from '@mui/material';
import { Close, WarningAmberOutlined } from '@mui/icons-material';
import { EDIT } from '../../constants/strings';

const IossErrorModal = ({ open, handleClose, basketItemId }) => (
  <Modal
    open={open}
    onClose={handleClose}
    aria-labelledby='ioss-error-title'
    aria-describedby='ioss-error-description'
  >
    <Card
      variant='elevation'
      sx={{
        position: 'relative',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        maxWidth: '500px',
        width: '100%',
      }}
      role='dialog'
    >
      <IconButton
        aria-label='close modal'
        sx={{ position: 'absolute', right: 5, top: 5, zIndex: 1 }}
        onClick={handleClose}
      >
        <Close />
      </IconButton>
      <CardHeader
        title={
          <Box display='flex' id='ioss-error-title'>
            <WarningAmberOutlined
              color='warning'
              sx={{ mr: 1 }}
              aria-hidden='true'
            />
            <Typography variant='h6' gutterBottom>
              Warning
            </Typography>
          </Box>
        }
      />
      <CardContent id='ioss-error-description'>
        <Typography variant='body1' gutterBottom>
          The selected service and destination country option is unavailable for
          one of the following reasons:
        </Typography>
        <Typography variant='body1' gutterBottom>
          • For Consumers: Goods valued below €150 require an IOSS VAT ID.
          Please enter your IOSS VAT ID or choose an air service to proceed.
        </Typography>
        <Typography variant='body1' gutterBottom>
          • For Businesses: Shipments with a customs value below €150 cannot be
          sent to a business address with the selected service. Please select an
          air service to continue.
        </Typography>
      </CardContent>
      {basketItemId && (
        <CardActions sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
          <Box>
            <Button
              variant='outlined'
              color='primary'
              onClick={handleClose}
              href={`/order?basketItemId=${basketItemId}`}
            >
              {EDIT}
            </Button>
          </Box>
        </CardActions>
      )}
    </Card>
  </Modal>
);

export default IossErrorModal;
